import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Gizmo, Minus } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import { Tooltip } from "@air/primitive-tooltip";
import { KanbanColumnHeaderDisplay } from "~/components/KanbanColumnHeaderDisplay";
import { KANBAN_COL_PX } from "~/components/KanbanView/shared/kanbanConstants";
import { KANBAN_COLUMN_HEADER } from "~/constants/testIDs";
export const KanbanColumnHeader = (param)=>{
    let { onHideColumn, itemCount, label, id, color, dndListeners } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex items-center justify-between gap-2",
        "data-testid": KANBAN_COLUMN_HEADER,
        style: {
            paddingTop: KANBAN_COL_PX - 6,
            paddingBottom: KANBAN_COL_PX - 6,
            paddingLeft: KANBAN_COL_PX,
            paddingRight: KANBAN_COL_PX
        },
        children: [
            /*#__PURE__*/ _jsx(KanbanColumnHeaderDisplay, {
                id: id,
                label: label,
                color: color,
                itemCount: itemCount
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center gap-2",
                children: [
                    onHideColumn && /*#__PURE__*/ _jsx(Tooltip, {
                        label: "Hide this column",
                        side: "top",
                        children: /*#__PURE__*/ _jsx(IconButton, {
                            appearance: "ghost",
                            color: "grey",
                            icon: Minus,
                            label: "Hide column",
                            size: "small",
                            onClick: onHideColumn
                        })
                    }),
                    dndListeners && /*#__PURE__*/ _jsx(IconButton, {
                        appearance: "ghost",
                        className: "cursor-grab active:cursor-grabbing",
                        color: "grey",
                        icon: Gizmo,
                        label: "Move",
                        size: "small",
                        ...dndListeners
                    })
                ]
            })
        ]
    });
};
